import { logError } from "../../helpers/errors";

// Adds a JS file to the document head
export const addJsFileToHead = (url: string): void => {
  const jsElement = document.createElement("script");
  jsElement.src = url;
  jsElement.type = "text/javascript";
  jsElement.dataset.chAsset = "true";

  const head = document.head;
  head.insertBefore(jsElement, head.childNodes[0]);
};

// Adds a CSS file to the document head
export const addCssFileToHead = (url: string): void => {
  const cssElement = document.createElement("link");
  cssElement.href = url;
  cssElement.rel = "stylesheet";
  cssElement.type = "text/css";
  cssElement.dataset.chAsset = "true";

  const head = document.head;
  head.insertBefore(cssElement, head.childNodes[0]);
};

/**
 * Gets an array of asset manifest entries for building the global header or
 * logs and returns an empty array if the request fails
 */
export const getGlobalHeaderAssetEntries = async (
  manifestURL: string
): Promise<string[]> => {
  try {
    const res = await fetch(manifestURL);
    const json = await res.json();
    return json.entrypoints || [];
  } catch (err) {
    const e = err as Error;
    logError(e.message, e);
    return [];
  }
};

export const replaceUserName = (
  searchName: string,
  replacementName: string
) => {
  const oldName = searchName.split(" ")[0];
  const newName = replacementName.split(" ")[0];
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    null
  );
  let currentNode;
  while ((currentNode = walker.nextNode())) {
    // Check if the text node contains the name substring
    if (currentNode.nodeValue?.includes(oldName)) {
      // Replace all occurrences of the name inside this specific text node
      currentNode.nodeValue = currentNode.nodeValue.replaceAll(
        oldName,
        newName
      );
    }
  }
};
